import { GetServerSidePropsContext } from 'next';

import { Enum } from '@utils/enum';

export const roles = Enum(
  'ADMIN',
  'BROKER',
  'BROKER_EDITOR',
  'BUYOUT_AGENT',
  'INTERNAL_USER',
  'EDITOR',
  'ATLAS_VIEWER',
  'ATLAS_MODIFICATIONS_REVIEWER',
);

export type Role = keyof typeof roles;

export type TokenType =
  | 'SERVICE_ACCOUNT'
  | 'USER'
  | 'REFRESH_TOKEN'
  | 'SERVICE';

export const loginReasons = Enum(
  'logout',
  'login_required',
  'missing_role',
  'session_expired',
);

export type LoginReason = keyof typeof loginReasons;

export type ServerSideContext = Partial<GetServerSidePropsContext> | void;
